//WARNING: We have made our own changes to the navx library, the file can be found in: wwwroot/lib/header/_dst/js/navigation.js
export function navInit() {


    var navigation = new Navigation(document.getElementById("navigation"), {
        onInit: function () {

            //console.log("navx initialisation onInit");

            const navItems = document.querySelectorAll(".navigation-item .navigation-link");

            // Nav animation will only run once per user session.
            const isAnimationDisabled = sessionStorage.getItem("nav-animation-active");

            if (!isAnimationDisabled) {
                anime({
                    targets: navItems,
                    opacity: [0, 1],
                    translateY: [-50, 0],
                    duration: 800,
                    delay: anime.stagger(200), // increase delay by 100ms for each elements.
                    easing: "cubicBezier(0.22, 1, 0.36, 1)",
                    complete: function () {
                        sessionStorage.setItem("nav-animation-active", true);
                    }
                });
            }
        }
    });

    if ($('#upper-header').length > 0) {
        window.onscroll = function () {
            var scrollPosY = window.pageYOffset | document.body.scrollTop;

            var elmnt = document.getElementById("upper-header");
            if (scrollPosY > elmnt.offsetHeight) {
                navigation.classList.remove("navigation-transparent");
            } else {
                navigation.classList.add("navigation-transparent");
            }
        }
    }
}
